import { CurrencyBrlIcon } from './CurrencyBrlIcon';

/**
 * author: Austin Andrews
 * id 20E50505-DD23-4A07-AAE7-024BE3774018
 * name currency-brl
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-brl.svg
 * tags
 * - Banking 
 * - Currency 
 */
export const BrazilianRealIcon = CurrencyBrlIcon;
export default BrazilianRealIcon